<template>
  <app-side-menu>
    <aside
      class="menu"
      slot="side-menu">
      <p class="menu-label">
        <span class="title is-6">
          PNET Message Details
        </span>
      </p>
      <ul class="menu-list">
        <li>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                v-model="value.uid"
                placeholder="UID"
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <input
                class="input is-capitalized"
                type="text"
                v-model="value.messageNo"
                placeholder="Message No."
                @keyup.enter="onFilterClick()">
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.messageTypeEnum">
                  <option value="">-- Message Type --</option>
                  <option :value="messageTypeEnum.QREQ">QREQ</option>
                  <option :value="messageTypeEnum.ADQT">ADQT</option>
                  <option :value="messageTypeEnum.AUQT">AUQT</option>
                  <option :value="messageTypeEnum.ARES">ARES</option>
                  <option :value="messageTypeEnum.RRQT">RRQT</option>
                  <option :value="messageTypeEnum.QRCN">QRCN</option>
                  <option :value="messageTypeEnum.QTDL">QTDL</option>
                  <option :value="messageTypeEnum.BACA">BACA</option>
                  <option :value="messageTypeEnum.QMQR">QMQR</option>
                  <option :value="messageTypeEnum.EWAP">EWAP</option>
                  <option :value="messageTypeEnum.MANQ">MANQ</option>
                  <option :value="messageTypeEnum.BCQR">BCQR</option>
                  <option :value="messageTypeEnum.OUTBOUND_QUOTE">Outbound Quote</option>
                  <option :value="messageTypeEnum.UPDATE_REPAIR_STATUS">Update Repair Status</option>
                  <option :value="messageTypeEnum.TAX_INVOICE">Tax Invoice</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.messageStatusTypeEnum">
                  <option value="">-- Message Status --</option>
                  <option :value="messageStatusTypeEnum.ToSend">To Send</option>
                  <option :value="messageStatusTypeEnum.Sent">Sent</option>
                  <option :value="messageStatusTypeEnum.UnRead">UnRead</option>
                  <option :value="messageStatusTypeEnum.Read">Read</option>
                  <option :value="messageStatusTypeEnum.Failed">Failed</option>
                  <option :value="messageStatusTypeEnum.InComplete">In Complete</option>
                  <option :value="messageStatusTypeEnum.Deleted">Deleted</option>
                  <option :value="messageStatusTypeEnum.DeletedRecord">Deleted Record</option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="value.messageDirection">
                  <option value="">-- Message Direction --</option>
                  <option value="0">Incoming</option>
                  <option value="1">Outgoing</option>
                </select>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <hr>
    </aside>
  </app-side-menu>
</template>

<script>
import AppSideMenu from '@/components/AppSideMenu'
import { MessageStatusTypes, MessageTypes } from '@/enums'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'PnetMessageNewSideMenu',
  components: {
    AppSideMenu
  },
  props: {},
  data() {
    return {
      innerValue: _cloneDeep(this.value),
      value: {
      messageStatusTypeEnum: 30,
      messageDirection: 0,
      messageTypeEnum: 17
    }
    }
  },
  computed: {
    messageStatusTypeEnum() {
      return MessageStatusTypes
    },
    messageTypeEnum() {
      return MessageTypes
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  }
}
</script>
